if (!customElements.get("price-range")) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = this.querySelector(".price-range-number-min");
      this.maxNumberInput = this.querySelector(".price-range-number-max");
      this.minSliderInput = this.querySelector(".price-range-slider-min");
      this.maxSliderInput = this.querySelector(".price-range-slider-max");
      this.minLabel = this.querySelector(".price-range-label-min");
      this.maxLabel = this.querySelector(".price-range-label-max");
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.selectedTrack = this.querySelector(".selected-track");
      this.timeout = null;
      this.updateLabel();
      this.updateTrack();
      this.addEventListener("input", this.handleInput.bind(this));
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
          this.updateTrack();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
        this.updateTrack();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      this.minNumberInput.value =
        this.minSliderInput.value !== this.minNumberInput.min
          ? this.minSliderInput.value
          : null;

      this.maxNumberInput.value =
        this.maxSliderInput.value !== this.maxNumberInput.max
          ? this.maxSliderInput.value
          : null;
      this.updateLabel();
    }

    /**
     * Updates the value of the 'label'.
     */
    updateLabel() {
      this.minLabel.innerText =
        this.minSliderInput.value !== this.minNumberInput.min
          ? this.minSliderInput.value
          : this.minNumberInput.min;

      this.maxLabel.innerText =
        this.maxSliderInput.value !== this.maxNumberInput.max
          ? this.maxSliderInput.value
          : this.maxNumberInput.max;

      if (this.minLabel.innerText == this.minNumberInput.min) {
        this.minLabel.style.color = "#A3A3A3";
        this.minLabel.parentElement.style.color = "#A3A3A3";
      }

      if (this.maxLabel.innerText == this.minNumberInput.max) {
        this.maxLabel.style.color = "#A3A3A3";
        this.maxLabel.parentElement.style.color = "#A3A3A3";
      }
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      const minValue = parseInt(this.minNumberInput.value, 10);
      const maxValue = parseInt(this.maxNumberInput.value, 10);

      if (minValue > maxValue - 10) {
        if (evt.target === this.minNumberInput) {
          this.maxSliderInput.value = minValue + 10;

          if (maxValue === this.maxValue) {
            this.minSliderInput.value = this.maxValue - 10;
          }
        } else {
          this.minSliderInput.value = maxValue - 10;
        }
      }

      if (maxValue < minValue + 10) {
        if (evt.target === this.maxNumberInput) {
          this.minSliderInput.value = maxValue - 10;

          if (minValue === this.minValue) {
            this.maxSliderInput.value = 10;
          }
        } else {
          this.maxSliderInput.value = minValue + 10;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
      }

      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
      }
    }

    updateTrack() {
      const currentMin =
        this.minSliderInput.value !== this.minNumberInput.min
          ? this.minSliderInput.value
          : this.minNumberInput.min;
      const currentMax =
        this.maxSliderInput.value !== this.maxNumberInput.max
          ? this.maxSliderInput.value
          : this.maxNumberInput.max;

      const minPercent =
        ((currentMin - this.minValue) / (this.maxValue - this.minValue)) * 100;
      const maxPercent =
        ((currentMax - this.minValue) / (this.maxValue - this.minValue)) * 100;

      this.selectedTrack.style.left = minPercent + "%";
      this.selectedTrack.style.width = maxPercent - minPercent + "%";
    }
  }

  customElements.define("price-range", PriceRange);
}
